import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const ServicesContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(5, 2), // Reduced padding overall
    position: 'relative',
    backgroundColor: 'rgba(46, 54, 73, 0.6)',
    backdropFilter: 'blur(10px)',
    borderRadius: '16px',
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 4), // Restore larger padding on medium screens and up
    },
}));

export const ServiceCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '12px',
    overflow: 'hidden',
    background: 'transparent',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const ServiceIcon = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(3),
}));

export const ServiceContent = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    flexGrow: 1,
    backgroundColor: 'rgba(46, 54, 73, 0.6)',
    backdropFilter: 'blur(10px)',
}));
